// ══════════════════════════════════════════════════════════════════
// ES — reemplaza tu export const booking en el archivo de español
// ══════════════════════════════════════════════════════════════════
export const booking = {
  createBooking: "Crear reserva",
  detailsTitle: "Datos de la reserva",
  createdOn: "creada el",
  statusBooked: "Confirmada",
  processing: "Procesando...",
  reject: "Cancelar",
  cancelled: "Cancelada",
  guests: "Huéspedes",
  nights: "Noches",
 
  responsibleTitle: "Responsable de la reserva",
  name: "Nombre",
  email: "Correo electrónico",
  emailNotProvided: "No se proporcionó correo electrónico",
  phone: "Teléfono",
  phoneNotProvided: "No se proporcionó teléfono",
  replyWhatsapp: "Responder en WhatsApp",
  notes: "Observación",
  notesEmpty: "Sin observación",
  notesPlaceholder: "Notas internas de la reserva (ej. llega tarde, cuna, alergias…)",
  notesEdit: "Editar observación",
  notesSave: "Guardar",
  notesCancel: "Cancelar",
  notesSaved: "Observación actualizada",
  notesSaveError: "No se pudo guardar la observación",
 
  amountTitle: "Importe de la reserva",
 
  // Botones y estados del menú
  validatingLink: "Validando enlace...",
  sendPaymentLink: "Enviar link de pago",
  copyPaymentLink: "Copiar link de pago",
  sendingPaymentLink: "Enviando link de pago…",
  whatsappSent: "Link de pago enviado por WhatsApp.",
  whatsappSentFallback: "No se pudo enviar la plantilla. Se abrió WhatsApp manualmente.",
  freeReservationInfo: "Reserva gratuita - No requiere pago",
  stripeNotConfigured: "Stripe no configurado",
  changePaymentStatus: "Cambiar estado de pago",
 
  // Estado del importe
  amountStatus: "Estado del importe",
  paymentPending: "Pago pendiente",
  paid: "Pagado",
  rejected: "Rechazado",
  refunded: "Reembolsado",
  partial: "Pagada parcialmente",
 
  // Totales
  subtotal: "Subtotal:",
  totalDiscounts: "Descuentos totales:",
  totalTaxes: "Impuestos totales:",
  total: "Total:",
 
  // Modal de estado de pago
  changePaymentStatusHeader: "Cambiar estado de pago",
  paymentStatusLabel: "Estado de pago",
  select: "Seleccionar",
  pending: "Pendiente",
  paidShort: "Pagado",
  close: "Cerrar",
  saveChanges: "Guardar cambios",
 
  // Toastr / Mensajes
  paymentUrlSuccess: "URL de pago generada con éxito",
  paymentUrlError: "Error al generar la URL de pago",
 
  linkGenerated: "Enlace de pago generado correctamente",
  linkRegenerated: "Enlace de pago actualizado por cambios en el precio",
  linkPriceZero: "No se puede generar enlace de pago para reservas gratuitas ($0)",
  linkNoStripe: "El usuario no tiene configurado Stripe para recibir pagos",
  linkNoProvider: "No hay proveedor de pagos configurado (Stripe o Wompi)",  // ✅ NUEVA
  linkValidationFailed: "No se puede generar el enlace de pago. Faltan datos requeridos.",
  linkValidateError: "Error al validar el enlace de pago",
  linkValid: "El enlace de pago es válido",
 
  copySuccess: "El enlace se copió con éxito",
  copied: "¡Copiado!",
  copyError: "Hubo un error al copiar el enlace",
  error: "Error",
  statusUpdatedSuccess: "Estado actualizado con éxito",
  statusUpdatedError: "Error al actualizar el estado de pago",  // ✅ NUEVA
 
  // WhatsApp
  whatsappPayMessage: "Hola {name}! Este es tu enlace para realizar el pago de tu reserva: {url}",
 
  checkinsOf: "Check-in realizados en la reserva ({done} de {total})",
  completed: "Completados",
  pendings: "Pendientes",
  date: "Fecha",
  noCheckinsYet: "Los huéspedes de esta reserva no han realizado el check-in",
 
  alojamiento: "Alojamiento",
};
 
